/**
 * DEMO ONLY — Dynamic Pricing Slabs concept preview.
 *
 * Standalone, no backend, mock data. Route: /demo/dynamic-pricing (see App.js).
 * Throwaway — delete this folder + its route + import when real implementation starts.
 * See price_book_update/plans_and_actions/08-demo-screen.md.
 */
import React, { useState } from "react";
import {
  Box,
  Container,
  Tabs,
  Tab,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import { RestartAlt } from "@mui/icons-material";
import { DemoProvider, useDemo } from "./demoStore";
import DemoRibbon from "./DemoRibbon";
import DemoNotes from "./DemoNotes";
import DefineBandsView from "./views/DefineBandsView";
import ConfigureProductView from "./views/ConfigureProductView";
import PriceGridView from "./views/PriceGridView";

const TABS = [
  { label: "1 · Define bands", el: <DefineBandsView /> },
  { label: "2 · Configure product", el: <ConfigureProductView /> },
  { label: "3 · Price grid", el: <PriceGridView /> },
];

function DemoShell() {
  const [tab, setTab] = useState(0);
  const { dispatch } = useDemo();

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <DemoRibbon />
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Dynamic Pricing Slabs — concept demo
          </Typography>
          <Button
            size="small"
            startIcon={<RestartAlt />}
            onClick={() => {
              if (window.confirm("Reset the demo to the starting data?")) {
                dispatch({ type: "RESET_ALL" });
              }
            }}
          >
            Reset demo
          </Button>
        </Box>

        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
          variant="scrollable"
          scrollButtons="auto"
        >
          {TABS.map((t) => (
            <Tab key={t.label} label={t.label} />
          ))}
        </Tabs>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            {TABS[tab].el}
          </Grid>
          <Grid item xs={12} md={4}>
            <DemoNotes />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default function PriceBookDemo() {
  return (
    <DemoProvider>
      <DemoShell />
    </DemoProvider>
  );
}
